import { convertDateToTimezone } from "../../common/helpers/dateHelpers";

const convertEventDateToUserTimezone = (eventDate, userTimezoneOffset) => {
    let result = {
        ...eventDate,
        date: convertDateToTimezone(eventDate.dateUtc, userTimezoneOffset),
        periodDateUtc: eventDate.periodDateUtc
            ? convertDateToTimezone(eventDate.periodDateUtc, 0)
            : null,
    };
    return result;
};

export const convertEventDateListToUserTimezone = (
    eventDateList,
    userTimezoneOffset
) => {
    const result = eventDateList.map((ed) =>
        convertEventDateToUserTimezone(ed, userTimezoneOffset)
    );
    return result;
};

export const filterByEventName = (eventDateList, eventName) => {
    if (!eventName || eventName === "") return eventDateList;

    const filterName = eventName.replace(/\s+/g, "").toLowerCase();
    const result = eventDateList.filter((ed) => {
        return ed.name.replace(/\s+/g, "").toLowerCase().includes(filterName);
    });
    return result;
};

export const mapRevisedByPreviousIsPreliminary = (eventDates) => {
    return eventDates.map((item) => {
        return {
            ...item,
            revised: item.previousIsPreliminary ? null : item.revised,
        };
    });
};
